import { Component, Injector, Input, ViewChild, inject } from '@angular/core';
import { ApexAxisChartSeries, ApexTitleSubtitle, ApexDataLabels, ApexChart, ApexPlotOptions, ApexLegend, ChartComponent, ApexFill, ApexYAxis, ApexTooltip, ApexXAxis, ApexMarkers, ApexAnnotations, ApexGrid, ApexStroke, ApexTheme } from "ng-apexcharts";
import { ComponentBase } from '../../component-base';

export type ChartOptions = {
  series: ApexAxisChartSeries;
  colors: string[];
  chart: ApexChart;
  dataLabels: ApexDataLabels;
  title: ApexTitleSubtitle;
  plotOptions: ApexPlotOptions;
  legend: ApexLegend;
  xaxis: ApexXAxis;
  yaxis: ApexYAxis | ApexYAxis[];
  labels: string[];
  stroke: ApexStroke;
  fill: ApexFill;
  tooltip: ApexTooltip;
  markers: ApexMarkers;
  theme: ApexTheme;
  annotations: ApexAnnotations;
  grid: ApexGrid;
};

@Component({
  selector: 'stacked',
  templateUrl: './stacked.component.html',
  styleUrls: ['./stacked.component.scss']
})
export class StackedComponent extends ComponentBase {
  @ViewChild("chart", { static: false }) chart!: ChartComponent;
  @Input() options: Partial<ChartOptions> = {};
  @Input() height: number = 80;
  @Input() set series(value: any[]) {
    if (this._series != value) {
      this._series = value || [];
      this.buildChart();
    }
  }
  get series(): any[] {
    return this._series;
  }

  public chartOptions: Partial<ChartOptions>;

  private _series: any[] = [];

  constructor(public injector: Injector) {
    super(injector);
    this.chartOptions = {};
    this.buildChart();
  }

  public buildChart() {
    const max = this._series.reduce((a, v) => a += v.data[0], 0);
    this.chartOptions.series = this._series;
    this.chartOptions.chart = { type: "bar", stacked: true, height: this.height, toolbar: { show: false } };
    this.chartOptions.plotOptions = { bar: { horizontal: true } };
    this.chartOptions.xaxis = { categories: [""], max: max, labels: { show: false } };
    this.chartOptions.yaxis = { title: { text: undefined } };
    this.chartOptions.legend = { show: false };
    Object.assign(this.chartOptions, this.options);
    this.updateSeries();
  }

  public updateSeries() {
    if (this.series) this.chart?.updateSeries(this.series);
  }
}
